// extracted by mini-css-extract-plugin
export default {"post-detail-cards":"CardList_post-detail-cards__1d6YH","add-new":"CardList_add-new__Vumea","card":"CardList_card__XYeKc"};